(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var ticker = document.querySelector('[data-nsfg-ticker]');
    if (!ticker) return;
    var items = Array.from(ticker.querySelectorAll('.nsfg-bar__item'));
    if (items.length < 2) {
      if (items.length === 1) items[0].classList.add('is-active');
      return;
    }
    var current = 0;
    items[0].classList.add('is-active');
    setInterval(function () {
      var prev = current;
      current = (current + 1) % items.length;
      items[prev].classList.add('is-leaving');
      items[prev].classList.remove('is-active');
      items[current].classList.add('is-active');
      var leaving = items[prev];
      setTimeout(function () {
        leaving.classList.remove('is-leaving');
      }, 500);
    }, 4000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nsfg-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var filterBtns = document.querySelectorAll('[data-nsfg-faq-filter]');
    if (!filterBtns.length) return;

    filterBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-nsfg-faq-filter');

        filterBtns.forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');

        document.querySelectorAll('[data-nsfg-faq-cat]').forEach(function (item) {
          if (item.getAttribute('data-nsfg-faq-cat') === target) {
            item.removeAttribute('hidden');
          } else {
            item.setAttribute('hidden', '');
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nsfg-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var burger = document.querySelector('[data-nsfg-burger]');
    var drawer = document.getElementById('nsfg-nav-drawer');
    var drawerClose = document.querySelector('[data-nsfg-drawer-close]');

    function openDrawer() {
      drawer.showModal();
      burger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      drawer.close();
      burger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    if (burger && drawer) {
      burger.addEventListener('click', openDrawer);
    }

    if (drawerClose) {
      drawerClose.addEventListener('click', closeDrawer);
    }

    if (drawer) {
      drawer.addEventListener('click', function (e) {
        if (e.target === drawer) closeDrawer();
      });

      drawer.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeDrawer();
      });
    }

    var parents = document.querySelectorAll('[data-nsfg-parent]');
    parents.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.nsfg-header__item');
        var isOpen = item.classList.contains('nsfg-header__item--open');
        document.querySelectorAll('.nsfg-header__item--open').forEach(function (el) {
          el.classList.remove('nsfg-header__item--open');
          el.querySelector('[data-nsfg-parent]').setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('nsfg-header__item--open');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.nsfg-header__item')) {
        document.querySelectorAll('.nsfg-header__item--open').forEach(function (el) {
          el.classList.remove('nsfg-header__item--open');
          el.querySelector('[data-nsfg-parent]').setAttribute('aria-expanded', 'false');
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nsfg-policy"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var content = document.querySelector('[data-nsfg-policy-content]');
    var tocNav = document.querySelector('[data-nsfg-toc]');
    if (!content || !tocNav) return;

    var headings = Array.from(content.querySelectorAll('h2'));
    if (!headings.length) return;

    headings.forEach(function (h, i) {
      if (!h.id) h.id = 'policy-section-' + i;
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent;
      tocNav.appendChild(a);
    });

    var links = Array.from(tocNav.querySelectorAll('a'));

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          links.forEach(function (l) { l.classList.remove('is-active'); });
          var active = tocNav.querySelector('a[href="#' + entry.target.id + '"]');
          if (active) active.classList.add('is-active');
        }
      });
    }, { rootMargin: '-20% 0px -70% 0px' });

    headings.forEach(function (h) { observer.observe(h); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hero"] && !Shopify.designMode) return;
  try {
    
class NsfgProductPage{constructor(el){this.el=el;this.productId=el.dataset.productId;if(!this.productId)return;var s=document.getElementById('pdp-variants-'+this.productId);if(!s)return;try{this.variants=JSON.parse(s.textContent)}catch(e){return}this.selectedOptions={};this.variantInput=document.getElementById('pdp-variant-'+this.productId);this.priceWrap=document.getElementById('pdp-price-'+this.productId);this.atcBtn=document.getElementById('pdp-atc-'+this.productId);this.atcText=document.getElementById('pdp-atc-text-'+this.productId);this.mainImage=el.querySelector('.nsfg-pdp__image');this.seedOptions();this.bindOptions();this.bindThumbs()}seedOptions(){var self=this;this.el.querySelectorAll('.nsfg-pdp__opt-btn.is-active').forEach(function(b){self.selectedOptions[b.dataset.optionPos]=b.dataset.optionVal})}bindOptions(){var self=this;this.el.querySelectorAll('.nsfg-pdp__opt-btn').forEach(function(btn){btn.addEventListener('click',function(){if(btn.classList.contains('is-sold-out'))return;var pos=btn.dataset.optionPos,val=btn.dataset.optionVal;self.selectedOptions[pos]=val;self.el.querySelectorAll('.nsfg-pdp__opt-btn[data-option-pos="'+pos+'"]').forEach(function(b){var a=b.dataset.optionVal===val;b.classList.toggle('is-active',a);b.setAttribute('aria-checked',String(a))});var lbl=document.getElementById('pdp-opt-sel-'+self.productId+'-'+pos);if(lbl)lbl.textContent=val;self.applyVariant()})})}bindThumbs(){var self=this;var thumbs=this.el.querySelectorAll('.nsfg-pdp__thumb');thumbs.forEach(function(t){t.addEventListener('click',function(){var src=t.dataset.imageSrc;if(self.mainImage&&src)self.mainImage.src=src;thumbs.forEach(function(x){x.classList.remove('is-active')});t.classList.add('is-active')})})}applyVariant(){var self=this;var match=this.variants.find(function(v){return Object.keys(self.selectedOptions).every(function(p){return v['option'+p]===self.selectedOptions[p]})});if(!match)return;if(this.variantInput)this.variantInput.value=match.id;this.updatePrice(match);this.updateAtc(match);if(match.featured_image&&this.mainImage&&match.featured_image.src)this.mainImage.src=match.featured_image.src}updatePrice(v){if(!this.priceWrap)return;var fmt=function(c){return'$'+(c/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,',')};var pe=this.priceWrap.querySelector('.nsfg-pdp__price-current'),ce=this.priceWrap.querySelector('.nsfg-pdp__price-compare'),se=this.priceWrap.querySelector('.nsfg-pdp__price-save');if(pe)pe.textContent=fmt(v.price);var hc=v.compare_at_price&&v.compare_at_price>v.price;if(ce)ce.hidden=!hc;if(se)se.hidden=!hc;if(hc){if(ce)ce.textContent=fmt(v.compare_at_price);if(se)se.textContent='Save '+fmt(v.compare_at_price-v.price)}}updateAtc(v){if(!this.atcBtn||!this.atcText)return;this.atcBtn.disabled=!v.available;this.atcText.textContent=v.available?(this.atcBtn.dataset.addLabel||'Add to Cart'):'Sold Out'}}
document.querySelectorAll('.nsfg-pdp[data-product-id]').forEach(function(el){new NsfgProductPage(el)});

  } catch(e) { console.error(e); }
})();
})();
